import { render, staticRenderFns } from "./ArbitrationsRow.vue?vue&type=template&id=71c81822"
import script from "./ArbitrationsRow.vue?vue&type=script&lang=js"
export * from "./ArbitrationsRow.vue?vue&type=script&lang=js"
import style0 from "./ArbitrationsRow.vue?vue&type=style&index=0&id=71c81822&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports